import Vue from 'vue'
import App from './App.vue'
import router from './app/router'
import { store } from './app/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueHotkey from 'v-hotkey'
import VueCookies from 'vue-cookies'
import VueYandexMetrika from 'vue-yandex-metrika'

Vue.use(VueHotkey)
Vue.use(VueCookies)

const baseURL = process.env.VUE_APP_SERVER_TYPE === 'local'
	? "http://rszff.lh"
	: process.env.NODE_ENV === "production"
		? "https://creative.roasup.com"
		: "https://rsz-dev.roasup.com";
Vue.prototype.$buildType = process.env.VUE_APP_BUILD_TYPE ? process.env.VUE_APP_BUILD_TYPE : process.env.NODE_ENV;
Vue.prototype.$baseURL = baseURL;
Vue.prototype.$localToken = process.env.VUE_APP_LOCAL_TOKEN ? process.env.VUE_APP_LOCAL_TOKEN : null;

Vue.use(VueYandexMetrika, {
	id: 67319848,
	router: router,
	env: Vue.prototype.$buildType !== 'local' ? 'production' : 'local',
	options: {
		clickmap: true,
		trackLinks: true,
		accurateTrackBounce: true,
		webvisor: true
	},
	//debug: true
	// other options
})

Vue.use(VueAxios, axios.create({
	baseURL: baseURL + '/api'
}));
Vue.config.productionTip = false;

const CancelToken = axios.CancelToken;
const axiosCancelTokenSource = CancelToken.source();
Vue.prototype.$axiosCancelTokenSource = axiosCancelTokenSource;

export const $eventsBus = new Vue();

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
